const axios = require('axios')
const config = require('../../config.js')

const init = async function() {
  try {
    return axios.create({
      baseURL: config.API_URL,
      headers: {
        'content-type': 'application/json',
        "Access-Control-Allow-Origin": "*"
      }
    })
  } catch (e) {
    throw new Error(e)
  }
}

const post = async function(
  route /* : string */,
  payload /* : mixed */
) /* : Promise<void> */ {
  try {
    const instance = await init()

     console.log("making POST request to", 'color: #3d3d3d; background: rgba(228,147,77,1);', route)

     //console.log('with following payload: ')

     console.log(JSON.stringify(payload, null, 2))

    await instance.post(route, payload)
    .then(function (response) {
    // handle success
    // console.log(response)
    return response
  })
  } catch (error) {
    console.error(
      `An error has occurred while attempting POST request to ${route}: ${error}, ${error.details}, ${error.message}`
    )
  }
}

const get = async function(route /* : string */) /* : Promise<mixed> */ {
  try {
    const instance = await init()

    console.log("%cMaking GET request to", 'color: #3d3d3d; background: rgba(54,167,246,1);', route)



    return instance.get(route)
  } catch (error) {
    console.log(
      `An error has occurred attempting while attempting GET request to ${route}: ${error}, ${error.details}, ${error.message}`
    )
  }
}



export {
  post,
  get
}
